import type { FeatureKey } from "./features";
import { item, type NavItem } from "./navigation-item";

/** The one building screen the console opens too: the member's own profile, where two-factor is set
 * up. */
export const CONSOLE_ALSO_OPENS: ReadonlySet<FeatureKey> = new Set<FeatureKey>(["settings"]);

/** The platform console's own screens, for the platform team outside any organization. Each opens
 * in one of the console's workspaces (workspace-list-platform.ts), never in a tenant's. */
const PLATFORM = { platformOnly: true } as const;

export const PLATFORM_NAVIGATION: readonly NavItem[] = [
  item(
    "platform-calls",
    "People AI calls",
    "/platform/calls",
    "front-desk",
    "platform:read",
    PLATFORM,
  ),
  item(
    "platform-conversations",
    "People AI conversations",
    "/platform/conversations",
    "sales-assistant",
    "platform:read",
    PLATFORM,
  ),
  item(
    "platform-leads",
    "People AI leads",
    "/platform/leads",
    "sales-assistant",
    "platform:read",
    PLATFORM,
  ),
  item("platform-lines", "People AI lines", "/platform/lines", "front-desk", "platform:read", {
    ...PLATFORM,
    surface: "settings",
    scope: "platform",
    settingsCategory: "Phone & messaging",
  }),
  item("platform-desk", "People AI desk", "/platform/desk", "front-desk", "platform:read", {
    ...PLATFORM,
    surface: "settings",
    scope: "platform",
    settingsCategory: "Front desk",
  }),
  item(
    "platform-sales-assistant",
    "People AI sales assistant",
    "/platform/sales-assistant",
    "sales-assistant",
    "platform:read",
    { ...PLATFORM, surface: "settings", scope: "platform", settingsCategory: "Sales assistant" },
  ),
  item("support-desk", "Support desk", "/support-desk", "support", "platform:read", PLATFORM),
  item(
    "platform-form-requests",
    "Form requests",
    "/platform/form-requests",
    "support",
    "platform:read",
    PLATFORM,
  ),
  item(
    "platform-aria-feedback",
    "Aria feedback",
    "/platform/aria-feedback",
    "support",
    "platform:read",
    PLATFORM,
  ),
  item("platform-team", "Platform team", "/platform/team", "administration", "platform:read", {
    ...PLATFORM,
  }),
  item("platform-roles", "Native roles", "/platform/roles", "administration", "platform:read", {
    ...PLATFORM,
  }),
  item(
    "platform-activity",
    "Platform activity",
    "/platform/activity",
    "administration",
    "platform:read",
    PLATFORM,
  ),
  item(
    "platform-settings",
    "Platform settings",
    "/platform/settings",
    "administration",
    "platform:read",
    { ...PLATFORM, surface: "settings", scope: "platform", settingsCategory: "Platform" },
  ),
];
